import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allPrivateNetworks: [{}],
  customerPrivateNetworks: [{}],
  privateNetwork: {},
  privateNetworkRowData: {},
  allPrivateNetworkOrders: [{}],
  allSitesPrivateNetworkOrders: [],
  allSitesPublicNetworks: [],
  customerPrivateNetworkOrders: [{}],
  createdPrivateNetworkOrder: {},
  customerPublicNetwork: [{}],
  deletedPrivateNetworkOrder: {},
  deletedPrivateNetwork: {},
  allPublicNetworks: [{}],
  createdPublicNetwork: {},
  allAvailablePublicIPs: [{}],
  publicNetwork: [{}],
  deletedPublicNetwork: {},
  attachPrivateNetworkToggle: false,
  error: null,
  customerAllPrivateNetworks: [],
  customerPrivateNetworksForDashboard: {},
  syncPrivateNetwork: '',
  isLoading: false,
};

const privateNetworkSlice = createSlice({
  name: 'privateNetwork',
  initialState,
  reducers: {
    start: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    setReducerError: (state, action) => {
      state.error = action.error;
      state.isLoading = false;
    },
    setCustomerAllPrivateNetworks: (state, action) => {
      state.customerAllPrivateNetworks = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setSyncPrivateNetworks: (state, action) => {
      state.isLoading = false;
      state.syncPrivateNetwork = action.payload;
      state.error = null;
    },
    setAllPrivateNetworks: (state, action) => {
      state.allPrivateNetworks = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setCustomerPrivateNetworks: (state, action) => {
      state.customerPrivateNetworks = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPrivateNetwork: (state, action) => {
      state.privateNetwork = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAllPrivateNetworkOrders: (state, action) => {
      state.allPrivateNetworkOrders = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAllSitesPrivateNetworkOrders: (state, action) => {
      state.allSitesPrivateNetworkOrders = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setCustomerPrivateNetworkOrders: (state, action) => {
      state.customerPrivateNetworkOrders = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setCreatedPrivateNetworkOrder: (state, action) => {
      state.createdPrivateNetworkOrder = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setDeletedPrivateNetworkOrder: (state, action) => {
      state.deletedPrivateNetworkOrder = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setDeletedPrivateNetwork: (state, action) => {
      state.deletedPrivateNetwork = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAllPublicNetworks: (state, action) => {
      state.allPublicNetworks = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAllSitesPublicNetworks: (state, action) => {
      state.allSitesPublicNetworks = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setCreatedPublicNetwork: (state, action) => {
      state.createdPublicNetwork = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAllAvailablePublicIPs: (state, action) => {
      state.allAvailablePublicIPs = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPublicNetwork: (state, action) => {
      state.publicNetwork = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setCustomerPublicNetwork: (state, action) => {
      state.customerPublicNetwork = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setDeletePublicNetwork: (state, action) => {
      state.deletedPublicNetwork = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPrivateNetworkRowData: (state, action) => {
      state.privateNetworkRowData = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAttachPrivateNetworkToggle: (state, action) => {
      state.attachPrivateNetworkToggle = !state.attachPrivateNetworkToggle;
    },
    setCustomerPrivateNetworksForDashboard: (state, action) => {
      state.customerPrivateNetworksForDashboard = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setResetPrivateNetwork: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setSyncPrivateNetworks,
  setCustomerPrivateNetworksForDashboard,
  setAllPrivateNetworks,
  setCustomerPrivateNetworks,
  setPrivateNetwork,
  setAllPrivateNetworkOrders,
  setAllSitesPrivateNetworkOrders,
  setCustomerPrivateNetworkOrders,
  setCreatedPrivateNetworkOrder,
  setDeletedPrivateNetworkOrder,
  setDeletedPrivateNetwork,
  setAllPublicNetworks,
  setCreatedPublicNetwork,
  setAllAvailablePublicIPs,
  setPublicNetwork,
  setCustomerPublicNetwork,
  setDeletePublicNetwork,
  setAttachPrivateNetworkToggle,
  setAllSitesPublicNetworks,
  setCustomerAllPrivateNetworks,
  setPrivateNetworkRowData,
  setResetPrivateNetwork,
} = privateNetworkSlice.actions;

export default privateNetworkSlice.reducer;
